import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=37dc6bee&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37dc6bee')) {
      api.createRecord('37dc6bee', component.options)
    } else {
      api.reload('37dc6bee', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=37dc6bee&", function () {
      api.rerender('37dc6bee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2PyppVq2E3p5j/JS/videoIframe.vue"
export default component.exports